import sectionBlock from './section.block';
import keyMetrics from './keymetrics';
import offerBlock from './offer.block';
import offerListBlock from './offer.list.block';
import dealerSearchBlock from './dealer.search.block';
import dealerBlock from './dealer.block';
import errorBlock from './error.block';
import errorSlpBlock from './error.slp.block';
import linkBlock from './link.block';
import seriesBlock from './series.block';
import compareBlock from './compare.block';
import globalBlock from './global.block';
import listBlock from './list.block';
import listItemBlock from './list.item.block';
import userBlock from './user.block';
import inventoryListBlock from './inventory.list.block';

export default {
  sectionBlock: sectionBlock,
  keyMetrics: keyMetrics,
  offerBlock: offerBlock,
  offerListBlock: offerListBlock,
  dealerSearchBlock: dealerSearchBlock,
  dealerBlock: dealerBlock,
  errorBlock: errorBlock,
  errorSlpBlock: errorSlpBlock,
  linkBlock: linkBlock,
  seriesBlock: seriesBlock,
  compareBlock: compareBlock,
  globalBlock: globalBlock,
  listBlock: listBlock,
  listItemBlock: listItemBlock,
  userBlock: userBlock,
  inventoryListBlock: inventoryListBlock
};
